import styled from '@emotion/styled';
import {mixinSVGIcon} from 'webapp-lib/styling';

export const OptionFilterInfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FiltersLabelSubtextWrapper = styled.span`
  color: var(--color-core-primary);
  margin-left: var(--gutter-very-tiny);
`;

export const FilteredOutWarning = styled.span`
  margin-left: auto;

  svg {
    ${mixinSVGIcon};
    color: var(--color-notification-important);
  }
`;
